export default "__VITE_ASSET__C_pAwg87__"